const listeners = new Set();

export const showAlert = (message) => {
  listeners.forEach((listener) => listener(message));
};

export const subscribeAlert = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
